import { connect } from 'react-redux'
// import React from 'react'
// import PropTypes from 'prop-types'
import R from 'ramda'
import { PAGES } from '../../constants'

import {
  getPageData
} from '_utils'

import {
  setNavigation
} from '_actions'

import {
  // create,
  refresh,
  patch,
  remove,
  deactivate,

  postLicensePool,
  patchLicensePool,
  upgradeLicensePool,
  deactivateLicensePool,
  addLicensePoolSublicense,
  removeLicensePoolSublicense,

  addNote,
  removeNote,

  postInvite,
  removeInvite,

  fetchAutocompleteSuggestions,
  setAutocompleteSelections,
  clearAutocompleteSuggestions,
  refreshList,

  removeKeyedSessionMachine,
  deactivateKey,
  postKey,

  activationCodesStatePath,
  activationCodesRefreshList,
  activationCodesDeactivate,
} from '_actions/institutions'

import Institutions from './page'

const mapStateToProps = state => ({
  institutionsPage: R.pathOr({}, ['pages', PAGES.INSTITUTIONS], state),
  getAcData: (institutionId) => getPageData(activationCodesStatePath(institutionId), state)
})

const mapDispatchToProps = dispatch => ({

  // institution actions
  onRefreshInstitution: R.compose(dispatch, refresh), // ({institutionId})
  onRemoveInstitution: R.compose(dispatch, remove), // ({institutionId, pageNum, perPage})
  onDeactivateInstitution: R.compose(dispatch, deactivate), // ({institutionId })
  onModifyOne: R.compose(dispatch, patch), // ({institutionId, payload})

  // inst license pool actions
  onAddInstitutionLicensePool: R.compose(dispatch, postLicensePool), // ({ institutionId, payload })
  onDeactivateInstitutionLicensePool: R.compose(dispatch, deactivateLicensePool), // ({ institutionId, licensePoolId })
  onModifyInstitutionLicensePool: R.compose(dispatch, patchLicensePool), // ({ institutionId, licensePoolId, payload })
  onUpgradeInstitutionLicensePool: R.compose(dispatch, upgradeLicensePool), // ({ institutionId, licensePoolId })
  onAddSublicenseToInstitutionLicensePool: R.compose(dispatch, addLicensePoolSublicense), // ({ institutionId, licensePoolId, payload })
  onRemoveSublicenseFromInstitutionLicensePool: R.compose(dispatch, removeLicensePoolSublicense), // ({ institutionId, licensePoolId, sublicenseId })

  // notes actions
  onAddNote: R.compose(dispatch, addNote), // ({institutionId, payload})
  onRemoveNote: R.compose(dispatch, removeNote), // ({institutionId, noteId})
  goToPage: R.compose(dispatch, setNavigation, R.merge(R.__, {pageName: PAGES.INSTITUTIONS})), // navigation
  onRefreshList: R.compose(dispatch, refreshList), // navigation, aka R.pathOr({}, ['pages', PAGES.INSTITUTIONS, 'navigation'], this.props.state)
  onCreateInstitution: R.ifElse(
    institution => (institution && institution._id),
    R.compose(dispatch, setNavigation, institution => ({pageName: PAGES.INSTITUTIONS, ids: [institution._id]})),
    () => dispatch({type: 'noaction'})
  ),

  // inst invite actions
  onAddInstitutionInvite: R.compose(dispatch, postInvite), // ({institutionId, payload})
  onRemoveInstitutionInvite: R.compose(dispatch, removeInvite), // ({institutionId, inviteId})

  // main inst autocomplete
  onTermChange: R.compose(dispatch, fetchAutocompleteSuggestions), // {term, pageNum}
  onSelectionChange: R.compose(dispatch, setAutocompleteSelections), // selections
  onClearSuggestions: R.compose(dispatch, clearAutocompleteSuggestions), // selections

  // keys
  keyFuncs: {
    onAddKey: R.compose(dispatch, postKey), // ({institutionId, payload})
    onRemoveKey: R.compose(dispatch, deactivateKey), // ({institutionId, keyId})
    onRemoveKeyMachine: R.compose(dispatch, removeKeyedSessionMachine) // ({institutionId, keyId, machineId})
  },
  // institutional Activation codes
  acFuncs: {
    onRefreshOwner: R.compose(dispatch, refresh), // ({institutionId})
    onRefreshInstitution: R.compose(dispatch, refresh), // ({institutionId})
    onDeactivateAc: R.compose(dispatch, activationCodesDeactivate), // ({institutionId, licenseId})
    setNavigation: R.compose(dispatch, setNavigation), // ({pageName, ids[]})
    goToPage: R.compose(dispatch, activationCodesRefreshList) // { institutionId, pageNum, perPage, ids, showExpired, filter }
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Institutions)



// WEBPACK FOOTER //
// ./webAdmin/components/institutions/index.js